import { Provider } from '@angular/core';
import {
  AbilityService as Provide,
  AbilityService as Value,
} from '@casl/angular';

export const AbilityServiceProvider: Provider = {
  provide: Provide,
  useClass: Value,
};
